import React, { useState } from "react";
import PropTypes from "prop-types";
import "./App.css";
import { QRCode } from "react-qrcode";

export default function App({ domain }) {
  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const [date, setDate] = useState("");
  // const [domain, setDomain] = useState("https://www.fachverband-klang.de");
  const [path, setPath] = useState(
    "mitglied-werden/antrag-auf-mitgliedschaft/"
  );

  // useEffect(() => {
  //   setDomain(window.location.origin);
  // }, []);

  const url = `${domain}/${path}?ref=${name}${code ? "_" + code : ""}${
    date ? "_" + date : ""
  }`;

  return (
    <div
      style={{
        maxWidth: 1000,
      }}
    >
      <style>{`
    * {
      box-sizing: border-box;
    }
    `}</style>
      <h1>QR-Code-Generator</h1>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          padding: 20,
          background: "#eee",
          borderRadius: 10,
        }}
      >
        <div
          style={{
            flexBasis: "49%",
            flexShrink: 0,
            flexGrow: 1,
            paddingRight: 20,
            display: "flex",
            flexDirection: "column",
            gap: 20,
          }}
        >
          <h3>Eingaben</h3>
          <Input onChange={setName} title="Name" value={name} />
          <Input onChange={setDate} title="Date" value={date} />
          <Input onChange={setCode} title="Code" value={code} />
        </div>
        <div
          style={{
            flexBasis: "49%",
            flexShrink: 0,
            flexGrow: 0,
            display: "flex",
            flexDirection: "column",
            gap: 20,
          }}
        >
          <h3>Generierte URL</h3>
          <code
            style={{
              background: "white",
              padding: 10,
              width: "100%",
              overflowX: "auto",
            }}
          >
            {url}
          </code>
          <h3>Genreireter QR-Code</h3>
          <p>
            Du kannst den Code herunterladen mit Rechtsklick auf den QR-Code und
            &quot;speichern unter&quot;.
          </p>
          <QRCode value={url} scale="7" type="image/jpeg" />

          <select
            onChange={(e) => setPath(e.target.value)}
            value={path}
            style={{ display: "none" }}
          >
            <option value="mitglied-werden/antrag-auf-mitgliedschaft/">
              Antrag auf Mitgliedschaft
            </option>
          </select>
        </div>
      </div>
    </div>
  );
}

const Input = ({ onChange, value, title }) => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      gap: 10,
      position: "relative",
    }}
  >
    <input
      onChange={(e) => onChange(e.target.value)}
      value={value}
      style={{
        padding: 10,
        border: 0,
        margin: 0,
      }}
    />
    <label
      style={{
        fontSize: 12,
        fontWeight: "700",
        margin: 0,
        lineHeight: 1,
      }}
    >
      {title}
    </label>
  </div>
);

App.defaultProps = {
  domain: "",
};

App.propTypes = {
  domain: PropTypes.string,
};
